import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../hooks";

export default function ProtectedRoute() {
  const { isAuthenticated, user } = useAuth();
  const loc = useLocation();

  if (!isAuthenticated || !user?.username) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  return <Outlet />;
}
